import script from "./cases.vue?vue&type=script&setup=true&lang=js"
export * from "./cases.vue?vue&type=script&setup=true&lang=js"

import "./cases.vue?vue&type=style&index=0&id=187e7daa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187e7daa"]])

export default __exports__